/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Nav_How_It_WorksInputs */

const en_landing_nav_how_it_works = /** @type {(inputs: Landing_Nav_How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it works`)
};

/**
* | output |
* | --- |
* | "How it works" |
*
* @param {Landing_Nav_How_It_WorksInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_nav_how_it_works = /** @type {((inputs?: Landing_Nav_How_It_WorksInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Nav_How_It_WorksInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_nav_how_it_works(inputs)
});